export const filterString = (string) => {
  const formattedString = string.replace("_", " ");
  return formattedString;
};
